import React, { useMemo } from 'react';
import { Branch } from '../../types/branch';
import './CompactBranchSelect.scss';
import { AdaptiveSelect } from '../AdaptiveSelect/AdaptiveSelect';

interface Props {
  value: string[];
  onChange: (branchIds: string[]) => void;
  branches: Branch[];
  className?: string;
}

interface BranchOption {
  label: string;
  value: string;
  color?: string;
}

// Branch filter of the reservations calendar: several branches can be chosen and the trigger shows none of them (the filter
// writes its own label next to it).
export const CompactBranchSelect = ({ value, onChange, branches, className }: Props) => {
  const branchOptions = useMemo(() => {
    return branches.map((branch) => ({
      label: branch.name,
      value: branch.id,
      color: branch.color,
    }));
  }, [branches]);

  const itemTemplate = (option: BranchOption) => (
    <div className='compact-branch-item'>
      <span className='branch-color-dot' style={{ backgroundColor: option.color ?? '#000000' }} />
      <span className='compact-branch-name'>{option.label}</span>
    </div>
  );

  return (
    <AdaptiveSelect
      value={value}
      onChange={onChange}
      options={branchOptions}
      className={className}
      itemTemplate={itemTemplate}
      selectedItemTemplate={() => null}
      isMultiple
      emptyFilterMessage='No se encontraron sucursales'
      placeholder='Buscar sucursal...'
      modalTitle='Seleccionar sucursal'
      searchPlaceholder='Buscar sucursal'
      isFilter
    />
  );
};
